<template>
  <div class="invitation_letter">
    <CCard title="Báo cáo giao việc" class="mb-2">
      <CCardHeader class="pt-1 pb-1">
           <h4>Báo cáo giao việc</h4>
      </CCardHeader>
      <CCardBody class="pt-1 pb-1">
        <CRow>
            <CCol sm="3" class="mb-2">
              <label class="mb-1">Phòng ban</label>
              <CSelect :value.sync="inputDepartment" :options="listDepartment" @change="getReportJobUBND"/>
            </CCol>
            <CCol sm="2" class="mb-2" hidden>
              <label class="mb-1">Loại giao việc</label>
              <CSelect :value.sync="inputJobType" :options="listJobType" @change="getReportJobUBND"/>
            </CCol>
            <CCol sm="2" class="mb-2" hidden>
              <label class="mb-1">Vai trò xử lý</label>
              <CSelect :value.sync="inputJobStatus" :options="listJobStatus" @change="getReportJobUBND"/>
            </CCol>
            <CCol sm="2" class="mr-2">
                <label class='mb-0'>Từ ngày</label>
                <b-form-datepicker
                  id="datepicker"
                  class="mt-1"
                  v-model="inputFromDate"
                  locale="vi"
                  placeholder="Chọn ngày"
                  :date-format-options="{ day: '2-digit', month: '2-digit', year: 'numeric' }"
                  :hide-header="true"
                  label-help=""
                  :value-as-date="true"
                  style="max-width: 150px; min-width: 135px;"
                ></b-form-datepicker>
            </CCol>
            <CCol sm="2" class="mr-1">
                <label class='mb-0'>Đến ngày</label>
                <b-form-datepicker
                  id="datepicker"
                  class="mt-1"
                  v-model="inputToDate"
                  locale="vi"
                  placeholder="Chọn ngày"
                  :date-format-options="{ day: '2-digit', month: '2-digit', year: 'numeric' }"
                  :hide-header="true"
                  label-help=""
                  :value-as-date="true"
                  style="max-width: 150px; min-width: 135px"
                ></b-form-datepicker>
            </CCol>
        </CRow>
        <CRow>
          <CCol sm="12" class="center">
                <vs-button style="min-width: 110px" warn square class="custom_btn_search"  @click="getReportJobUBND()"><i class='bx bx-search'></i>&nbsp;Tìm kiếm</vs-button>
            </CCol>
        </CRow>
      </CCardBody>
    </CCard>
    <CCard>
      <vue-good-table
        :columns="columns"
        :rows="data"
        compactMode
        :line-numbers="true"
        :sort-options="{
          enabled:false
        }"
      >
        <div slot="emptystate" style="margin-top: 10px; margin-bottom: 10px">
          Không có văn bản trong khoảng thời gian này
        </div>
      </vue-good-table> 
    </CCard>
  </div>
</template>

<script>
  import moment from "moment";
  import { mapState, mapActions } from "vuex";
  import ClientFactory from "@/api/ClientFactory";
  import { VueGoodTable } from 'vue-good-table';
  const dropdownsApi = ClientFactory.get("dropdowns");
  const iOfficeApi = ClientFactory.get("ioffices");
  
  export default {
    components: {
        VueGoodTable
    },
    data(){
      return {
        content: "",
        inputFromDate: new Date(),
        inputToDate: new Date(),
        documentNo:"",
        trich_yeu: "",
        ma_cong_van: -1,
        listDepartment: [],
        inputDepartment: -1,
        data: [],

        //Loại giao việc
        listJobType: [
          {
            value: -1,
            label: "Tất cả",
          },
          {
            value: 1,
            label: "VB giao việc từ UBND (chủ trì)",
          },
          {
            value: 2,
            label: "VB giao việc từ UBND (tham gia)",
          }
        ],
        inputJobType: -1,

        //Vai trò xử lý
        listJobStatus: [
          {
            value: 1,
            label: "Chủ trì (xử lý chính)",
          },
          {
            
            value: -1,
            label: "Tất cả",
          },
          
          {
            value: 0,
            label: "Phối hợp tham gia",
          }
        ],
        inputJobStatus: 1,
      };
    },
    async created() {
      this.inputFromDate = new Date(Date.now() - 15 * 24 * 60 * 60 * 1000);
      this.inputToDate = new Date(Date.now() + 2 * 24 * 60 * 60 * 1000);
      this.listDepartment = await this.getDepartments();
      //this.getInvitationLetter();
    },
    methods: {
      ...mapActions("ui", ['loading', 'closeLoading', 'notify']),
      /**
       * Lấy danh sách tất cả phòng ban. Dùng cho dropdown
       */
      async getDepartments() {
        let listDepartment = await iOfficeApi.getDepartment();
        return listDepartment?.data?.data;
      },

      getReportJobUBND: async function () {
        this.loading(this.$vs);
        this.data=[];
        let maphong = this.inputDepartment;
        let loaigiaoviec = this.inputJobType;
        let vaitro = this.inputJobStatus;
        let tungay = moment(this.inputFromDate).format("DD/MM/YYYY");
        let denngay = moment(this.inputToDate).format("DD/MM/YYYY");
        const { data } = await iOfficeApi.getReportJobUBND(maphong,loaigiaoviec,vaitro,tungay,denngay,"","");
        
        
        this.checkResponseData(data);
        
        this.closeLoading();
      },

      checkResponseData(data) {

      if(data.status == "0")
      { 
        this.data = data.data;
                console.log("data.data");
                console.log(this.data);
      }else{
        if(data.message != "Xin lỗi, không có dữ liệu")
          this.notify({
            error:true,
            title: "Thông báo",
            text: data.message
          });
      }
     },

      searchInvitationLetter(){
        this.getInvitationLetter();
      },
      CheckRole(id) {
        return this.AppActiveUser.role.includes(id);
      },
    },
    computed: {
      ...mapState("auth", ["AppActiveUser"]),
      columns() {
        const cols = [
          {
            label: 'Số ký hiệu VB giao',
            field: 'SO_HIEU',
            thClass: 'emu-vgt-thead-th text-center width-status',
            tdClass: 'emu-vgt-tbody-td text-center width-status',
            width: '100px',
          },
          {
            label: 'Trích yếu',
            field: 'TRICH_YEU',
            thClass: 'emu-vgt-thead-th text-center width-status',
            tdClass: 'emu-vgt-tbody-td',
          },
          {
            label: 'Nội dung chỉ đạo',
            field: 'NOIDUNG_CHIDAO',
            thClass: 'emu-vgt-thead-th text-center',
            tdClass: 'emu-vgt-tbody-td text-center',
            width: '200px',
          },
          {
            label: 'Hạn xử lý',
            field: 'HAN_XU_LY',
            thClass: 'emu-vgt-thead-th text-center width-status',
            tdClass: 'emu-vgt-tbody-td text-center width-status',
            width: '100px',
          },
          {
            label: 'Ngày hoàn thành',
            field: 'NGAY_HOAN_THANH',
            thClass: 'emu-vgt-thead-th text-center width-status',
            tdClass: 'emu-vgt-tbody-td text-center width-status',
            width: '100px',
          },
          {
            label: 'Đã hoàn thành trước hạn',
            field: 'DAHOANTHANH_TRUOCHAN',
            thClass: 'emu-vgt-thead-th text-center',
            tdClass: 'emu-vgt-tbody-td text-center',
            width: '60px',
          },
          {
            label: 'Đã hoàn thành trong hạn',
            field: 'DAHOANTHANH_TRONGHAN',
            thClass: 'emu-vgt-thead-th text-center',
            tdClass: 'emu-vgt-tbody-td text-center',
            width: '60px',
          },
          {
            label: 'Đã hoàn thành quá hạn',
            field: 'DAHOANTHANH_QUAHAN',
            thClass: 'emu-vgt-thead-th text-center',
            tdClass: 'emu-vgt-tbody-td text-center',
            width: '60px',
          },
          {
            label: 'Chưa hoàn thành trong hạn',
            field: 'CHUAHOANTHANH_TRONGHAN',
            thClass: 'emu-vgt-thead-th text-center',
            tdClass: 'emu-vgt-tbody-td text-center',
            width: '60px',
          },
          {
            label: 'Chưa hoàn thành quá hạn',
            field: 'CHUAHOANTHANH_QUAHAN',
            thClass: 'emu-vgt-thead-th text-center',
            tdClass: 'emu-vgt-tbody-td text-center',
            width: '60px',
          },
          // {
          //   label: 'Chủ trì',
          //   field: 'XU_LY_CHINH',
          //   thClass: 'emu-vgt-thead-th text-center',
          //   tdClass: 'emu-vgt-tbody-td text-center',
          //   width: '60px',
          // },
          // {
          //   label: 'Phối hợp',
          //   field: 'PHOI_HOP',
          //   thClass: 'emu-vgt-thead-th text-center',
          //   tdClass: 'emu-vgt-tbody-td text-center',
          //   width: '60px',
          // },
          {
            label: 'VB phúc đáp',
            field: 'VANBAN_PHUCDAP',
            thClass: 'emu-vgt-thead-th text-center',
            tdClass: 'emu-vgt-tbody-td text-center',
            width: '100px',
          },
          {
            label: 'Người xử lý',
            field: 'HO_TEN',
            thClass: 'emu-vgt-thead-th text-center',
            tdClass: 'emu-vgt-tbody-td text-center',
            width: '100px',
          }
        ]
        return cols;
      },
    },
    destroyed() {
      this.closeLoading();
    }
  };

</script>



<style lang="scss">
    .employee-dialog{
      padding-top:10px;
    }
    .invitation_letter{
      table.vgt-table td {
        vertical-align: inherit;
        color: black !important;
        font-size: 14.5px;
        //padding: 0.3rem !important;
        padding: 0em .75em .0em .75em;
      }
      .vgt-responsive {
        overflow-x: inherit;
      }
      .width-class{
        min-width: 3px !important;
      }
      .width-status{
        min-width: 10px !important;
      }
      .vs-checkbox-content{
        align-items: center;
        justify-content: center;
      }
    }
    
</style>